// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-shadow {
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* sombra preta translúcida */
  }
.text-shadow-black {
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* sombra preta translúcida */
  }
.text-shadow-red{
  text-shadow: 2px 2px 4px rgba(255, 0, 0, 0.7); /* Vermelho translúcido */
}
.text-shadow-blue{
  text-shadow: 0px 0px 10px rgba(0, 0, 255, 0.6); /* Azul brilhante */
}
.text-shadow-gray{
  text-shadow: 1px 1px 2px black, 2px 2px 4px gray;
}

/* Centralized control height for toolbar inputs/buttons/separators */
:root {
  --acp-control-height: calc(1.2em + 0.4rem + 1px);
}

.shadow-primary {
  box-shadow: 0 4px 6px rgba(var(--bs-primary-rgb), 0.5); /* Cor da sombra igual à primária */
}

.shadow-success {
  box-shadow: 0 4px 6px rgba(var(--bs-success-rgb), 0.5); /* Cor da sombra igual ao sucesso */
}
.shadow-red {
  box-shadow: 0 4px 6px rgba(255, 0, 0, 0.5); /* Sombra vermelha translúcida */
}

.shadow-blue {
  box-shadow: 0 4px 6px rgba(0, 0, 255, 0.5); /* Sombra azul translúcida */
}

.input-group-sm .btn-sm {
  height: calc(1.5em + 0.5rem + 2px); /* Mesma altura dos inputs - padrao Bootstrap */
  line-height: 1.25; /* Para centralizar o ícone no botão */
  padding: 0.25rem 0.5rem; /* Ajuste do preenchimento interno */
}


.search-input-group .input-group-text {
  height: calc(1.5em + 0.5rem + 2px) !important;
}

/* No ACP theme overrides applied here; use project defaults */

.text-nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; /* Opcional: Adiciona reticências se o texto for muito longo */
}

.sidebar {
  /* Estilos básicos da sidebar */
  background-color: #f8f9fa;
  padding: 20px;
  height: 100vh; /* Ajuste conforme necessário */
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar.open {
  width: 200px;
}

.sidebar.closed {
  width: 50px;
}

.sidebar .nav-link {
  color: #333;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;
}

.sidebar .nav-link:hover {
  background-color: #e9ecef;
}

.sidebar .nav-link i {
  margin-right: 8px;
}

.content {
  /* Estilos para o conteúdo principal */
  margin-left: 200px; /* Ajuste conforme necessário */
  padding: 5px;
  width: 100%;
}

/* Estilos compatíveis com toolbar do uex_web */
@media (max-width: 767.98px) {
  .botao-grid-2col {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    width: 100%;
  }
  .botao-grid-2col > *:nth-child(odd):last-child {
    grid-column: 1 / -1;
  }
  .botao-igual {
    width: 100%;
  }
  .toolbar-separator {
    display: none !important;
  }
  .modal-footer {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    padding: 0.5rem !important;
  }
  .modal-footer > *:nth-child(odd):last-child {
    grid-column: 1 / -1;
  }
  .modal-footer > .btn {
    width: 100%;
  }
}
@media (min-width: 768px) {
  .botao-grid-2col {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
  .botao-igual {
    width: auto;
  }
}
.toolbar-separator {
  display: inline-block;
  width: 1px;
  height: var(--acp-control-height); /* match buttons/input height */
  background-color: #dee2e6; /* match PageHeader border color */
  margin: 0 0.25rem; /* horizontal spacing matching toolbar gap */
  vertical-align: middle;
  border-radius: 1px;
}
.centralizar-se-impar {
  margin-left: 0.25rem;
}

/* Ajuste: aumentar levemente o tamanho dos botões da toolbar */
.botao-grid-2col .btn-sm,
.botao-igual {
  font-size: 0.84rem; /* aumentado levemente */
  padding: 0.26rem 0.5rem; /* um pouco mais de espaço interno */
  line-height: 1.1;
}
.botao-igual {
  display: inline-flex;
  align-items: center;
  gap: 0.36rem;
}
.botao-igual i {
  margin-right: 0.45rem;
}
/* removed per-button margins; toolbar gap handles spacing uniformly */

/* Make input-group-sm controls and text have equal height and centered icon */
.input-group-sm .form-control,
.input-group-sm .input-group-text {
  height: var(--acp-control-height);
  padding: 0.18rem 0.4rem;
  line-height: 1.1;
}
.input-group-text i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Slightly reduce the input font-size so it visually matches button text */
.input-group-sm .form-control {
  font-size: 0.82rem;
}

/* Make btn-sm visually aligned with input-group-sm height */
.botao-grid-2col .btn-sm,
.botao-igual,
.botao-grid-2col .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.18rem 0.4rem;
  height: var(--acp-control-height);
  font-size: 0.82rem;
  line-height: 1.1;
}

/* Strong normalization for toolbar to avoid subtle differences between pages */
.botao-grid-2col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
}
.botao-grid-2col, .botao-grid-2col * {
  box-sizing: border-box;
}
.botao-grid-2col .input-group-text,
.botao-grid-2col .form-control,
.botao-grid-2col .btn,
.botao-grid-2col .btn-sm,
.botao-grid-2col .toolbar-separator {
  height: var(--acp-control-height) !important;
  display: inline-flex !important;
  align-items: center !important;
}
.botao-grid-2col .input-group-text {
  padding: 0 0.4rem;
}
.botao-grid-2col .input-group {
  height: var(--acp-control-height);
  align-items: center;
}
.botao-grid-2col .input-group-text {
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
  font-size: 0.95rem;
}
.botao-grid-2col .input-group-text i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin: 0;
  font-size: 10.7px !important;
  transform: translateY(0.5px);
}
.botao-grid-2col .form-control {
  height: 100%;
  padding: 0 0.5rem;
  display: inline-flex;
  align-items: center;
}
.botao-grid-2col .input-group-text .visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0 0 0 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.botao-grid-2col .filter-clear-btn {
  height: var(--acp-control-height);
  padding: 0 0.4rem;
}

/* Ensure icons inside buttons are vertically centered */
.botao-grid-2col .btn i,
.botao-igual i {
  display: inline-flex;
  align-items: center;
}

/* Filled (non-outline) buttons should use white text for better contrast */
.btn:not([class*='btn-outline']):not(.btn-link):not(.btn-light) {
  color: #ffffff !important;
}
.btn:not([class*='btn-outline']):not(.btn-link):not(.btn-light) i {
  color: inherit !important;
}

/* Toolbar buttons inherit their natural colors; specific tones set for success/warning/danger above */

/* Diminuir tamanho do texto do footer */
.footer,
.footer p,
.footer .container,
.footer .container p,
.FooterLoginPage {
  font-size: 0.72rem;
}

/* Very specific override for filter icon in toolbar to guarantee alignment */
.botao-grid-2col .input-group-text > i.bi,
.botao-grid-2col .input-group-text > i {
  font-size: 10px !important;
  line-height: 1 !important;
  display: inline-block !important;
  transform: translateY(0.5px) !important;
}

`, "",{"version":3,"sources":["webpack://./src/service/css/Acp.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C,EAAE,6BAA6B;EAC5E;AACF;IACI,2CAA2C,EAAE,6BAA6B;EAC5E;AACF;EACE,6CAA6C,EAAE,yBAAyB;AAC1E;AACA;EACE,8CAA8C,EAAE,mBAAmB;AACrE;AACA;EACE,gDAAgD;AAClD;;AAEA,qEAAqE;AACrE;EACE,gDAAgD;AAClD;;AAEA;EACE,sDAAsD,EAAE,mCAAmC;AAC7F;;AAEA;EACE,sDAAsD,EAAE,mCAAmC;AAC7F;AACA;EACE,0CAA0C,EAAE,gCAAgC;AAC9E;;AAEA;EACE,0CAA0C,EAAE,4BAA4B;AAC1E;;AAEA;EACE,kCAAkC,EAAE,+CAA+C;EACnF,iBAAiB,EAAE,sCAAsC;EACzD,uBAAuB,EAAE,oCAAoC;AAC/D;;;AAGA;EACE,6CAA6C;AAC/C;;AAEA,8DAA8D;;AAE9D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAE,8DAA8D;AACzF;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,aAAa,EAAE,+BAA+B;EAC9C,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB,EAAE,+BAA+B;EACnD,YAAY;EACZ,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,WAAW;IACX,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,iCAAiC,EAAE,+BAA+B;EAClE,yBAAyB,EAAE,kCAAkC;EAC7D,iBAAiB,EAAE,4CAA4C;EAC/D,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;;EAEE,kBAAkB,EAAE,wBAAwB;EAC5C,uBAAuB,EAAE,oCAAoC;EAC7D,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA,sEAAsE;;AAEtE,8EAA8E;AAC9E;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;;;;;EAKE,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,sGAAsG;;AAEtG,wCAAwC;AACxC;;;;;EAKE,kBAAkB;AACpB;;AAEA,6EAA6E;AAC7E;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,uCAAuC;AACzC","sourcesContent":[".text-shadow {\r\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* sombra preta translúcida */\r\n  }\r\n.text-shadow-black {\r\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* sombra preta translúcida */\r\n  }\r\n.text-shadow-red{\r\n  text-shadow: 2px 2px 4px rgba(255, 0, 0, 0.7); /* Vermelho translúcido */\r\n}\r\n.text-shadow-blue{\r\n  text-shadow: 0px 0px 10px rgba(0, 0, 255, 0.6); /* Azul brilhante */\r\n}\r\n.text-shadow-gray{\r\n  text-shadow: 1px 1px 2px black, 2px 2px 4px gray;\r\n}\r\n\r\n/* Centralized control height for toolbar inputs/buttons/separators */\r\n:root {\r\n  --acp-control-height: calc(1.2em + 0.4rem + 1px);\r\n}\r\n\r\n.shadow-primary {\r\n  box-shadow: 0 4px 6px rgba(var(--bs-primary-rgb), 0.5); /* Cor da sombra igual à primária */\r\n}\r\n\r\n.shadow-success {\r\n  box-shadow: 0 4px 6px rgba(var(--bs-success-rgb), 0.5); /* Cor da sombra igual ao sucesso */\r\n}\r\n.shadow-red {\r\n  box-shadow: 0 4px 6px rgba(255, 0, 0, 0.5); /* Sombra vermelha translúcida */\r\n}\r\n\r\n.shadow-blue {\r\n  box-shadow: 0 4px 6px rgba(0, 0, 255, 0.5); /* Sombra azul translúcida */\r\n}\r\n\r\n.input-group-sm .btn-sm {\r\n  height: calc(1.5em + 0.5rem + 2px); /* Mesma altura dos inputs - padrao Bootstrap */\r\n  line-height: 1.25; /* Para centralizar o ícone no botão */\r\n  padding: 0.25rem 0.5rem; /* Ajuste do preenchimento interno */\r\n}\r\n\r\n\r\n.search-input-group .input-group-text {\r\n  height: calc(1.5em + 0.5rem + 2px) !important;\r\n}\r\n\r\n/* No ACP theme overrides applied here; use project defaults */\r\n\r\n.text-nowrap {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis; /* Opcional: Adiciona reticências se o texto for muito longo */\r\n}\r\n\r\n.sidebar {\r\n  /* Estilos básicos da sidebar */\r\n  background-color: #f8f9fa;\r\n  padding: 20px;\r\n  height: 100vh; /* Ajuste conforme necessário */\r\n  overflow-y: auto;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1000;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.sidebar.open {\r\n  width: 200px;\r\n}\r\n\r\n.sidebar.closed {\r\n  width: 50px;\r\n}\r\n\r\n.sidebar .nav-link {\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n.sidebar .nav-link:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.sidebar .nav-link i {\r\n  margin-right: 8px;\r\n}\r\n\r\n.content {\r\n  /* Estilos para o conteúdo principal */\r\n  margin-left: 200px; /* Ajuste conforme necessário */\r\n  padding: 5px;\r\n  width: 100%;\r\n}\r\n\r\n/* Estilos compatíveis com toolbar do uex_web */\r\n@media (max-width: 767.98px) {\r\n  .botao-grid-2col {\r\n    display: grid !important;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 0.5rem;\r\n    width: 100%;\r\n  }\r\n  .botao-grid-2col > *:nth-child(odd):last-child {\r\n    grid-column: 1 / -1;\r\n  }\r\n  .botao-igual {\r\n    width: 100%;\r\n  }\r\n  .toolbar-separator {\r\n    display: none !important;\r\n  }\r\n  .modal-footer {\r\n    display: grid !important;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 0.5rem;\r\n    padding: 0.5rem !important;\r\n  }\r\n  .modal-footer > *:nth-child(odd):last-child {\r\n    grid-column: 1 / -1;\r\n  }\r\n  .modal-footer > .btn {\r\n    width: 100%;\r\n  }\r\n}\r\n@media (min-width: 768px) {\r\n  .botao-grid-2col {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.25rem;\r\n  }\r\n  .botao-igual {\r\n    width: auto;\r\n  }\r\n}\r\n.toolbar-separator {\r\n  display: inline-block;\r\n  width: 1px;\r\n  height: var(--acp-control-height); /* match buttons/input height */\r\n  background-color: #dee2e6; /* match PageHeader border color */\r\n  margin: 0 0.25rem; /* horizontal spacing matching toolbar gap */\r\n  vertical-align: middle;\r\n  border-radius: 1px;\r\n}\r\n.centralizar-se-impar {\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n/* Ajuste: aumentar levemente o tamanho dos botões da toolbar */\r\n.botao-grid-2col .btn-sm,\r\n.botao-igual {\r\n  font-size: 0.84rem; /* aumentado levemente */\r\n  padding: 0.26rem 0.5rem; /* um pouco mais de espaço interno */\r\n  line-height: 1.1;\r\n}\r\n.botao-igual {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.36rem;\r\n}\r\n.botao-igual i {\r\n  margin-right: 0.45rem;\r\n}\r\n/* removed per-button margins; toolbar gap handles spacing uniformly */\r\n\r\n/* Make input-group-sm controls and text have equal height and centered icon */\r\n.input-group-sm .form-control,\r\n.input-group-sm .input-group-text {\r\n  height: var(--acp-control-height);\r\n  padding: 0.18rem 0.4rem;\r\n  line-height: 1.1;\r\n}\r\n.input-group-text i {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Slightly reduce the input font-size so it visually matches button text */\r\n.input-group-sm .form-control {\r\n  font-size: 0.82rem;\r\n}\r\n\r\n/* Make btn-sm visually aligned with input-group-sm height */\r\n.botao-grid-2col .btn-sm,\r\n.botao-igual,\r\n.botao-grid-2col .btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.18rem 0.4rem;\r\n  height: var(--acp-control-height);\r\n  font-size: 0.82rem;\r\n  line-height: 1.1;\r\n}\r\n\r\n/* Strong normalization for toolbar to avoid subtle differences between pages */\r\n.botao-grid-2col {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n.botao-grid-2col, .botao-grid-2col * {\r\n  box-sizing: border-box;\r\n}\r\n.botao-grid-2col .input-group-text,\r\n.botao-grid-2col .form-control,\r\n.botao-grid-2col .btn,\r\n.botao-grid-2col .btn-sm,\r\n.botao-grid-2col .toolbar-separator {\r\n  height: var(--acp-control-height) !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n}\r\n.botao-grid-2col .input-group-text {\r\n  padding: 0 0.4rem;\r\n}\r\n.botao-grid-2col .input-group {\r\n  height: var(--acp-control-height);\r\n  align-items: center;\r\n}\r\n.botao-grid-2col .input-group-text {\r\n  height: 100%;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 0.5rem;\r\n  font-size: 0.95rem;\r\n}\r\n.botao-grid-2col .input-group-text i {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1;\r\n  margin: 0;\r\n  font-size: 10.7px !important;\r\n  transform: translateY(0.5px);\r\n}\r\n.botao-grid-2col .form-control {\r\n  height: 100%;\r\n  padding: 0 0.5rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n.botao-grid-2col .input-group-text .visually-hidden {\r\n  position: absolute !important;\r\n  width: 1px !important;\r\n  height: 1px !important;\r\n  padding: 0 !important;\r\n  margin: -1px !important;\r\n  overflow: hidden !important;\r\n  clip: rect(0 0 0 0) !important;\r\n  white-space: nowrap !important;\r\n  border: 0 !important;\r\n}\r\n.botao-grid-2col .filter-clear-btn {\r\n  height: var(--acp-control-height);\r\n  padding: 0 0.4rem;\r\n}\r\n\r\n/* Ensure icons inside buttons are vertically centered */\r\n.botao-grid-2col .btn i,\r\n.botao-igual i {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Filled (non-outline) buttons should use white text for better contrast */\r\n.btn:not([class*='btn-outline']):not(.btn-link):not(.btn-light) {\r\n  color: #ffffff !important;\r\n}\r\n.btn:not([class*='btn-outline']):not(.btn-link):not(.btn-light) i {\r\n  color: inherit !important;\r\n}\r\n\r\n/* Toolbar buttons inherit their natural colors; specific tones set for success/warning/danger above */\r\n\r\n/* Diminuir tamanho do texto do footer */\r\n.footer,\r\n.footer p,\r\n.footer .container,\r\n.footer .container p,\r\n.FooterLoginPage {\r\n  font-size: 0.72rem;\r\n}\r\n\r\n/* Very specific override for filter icon in toolbar to guarantee alignment */\r\n.botao-grid-2col .input-group-text > i.bi,\r\n.botao-grid-2col .input-group-text > i {\r\n  font-size: 10px !important;\r\n  line-height: 1 !important;\r\n  display: inline-block !important;\r\n  transform: translateY(0.5px) !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
